import { Fragment, useContext, useEffect, useState } from 'react';
import UserContext from '../../context/userContext';
import { Loading } from '../Common/Loading';
import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, useDisclosure, Button } from '@chakra-ui/react';
import ModalTemporadas from './ModalTemporadas';
import { deleteTemporada, getMaxYear, getTemporadas, postTemporada, putTemporada } from '../../services/temporadas';
import Select from 'react-select';
import ConfirmModal from '../util/confirmModal/confirmModal';
import InfoModal from '../util/confirmModal/InfoModal';
import { useTranslation } from 'react-i18next';

const Temporadas = () => {
  const { t } = useTranslation();
  const { user, isLoadingContext, setIsLoadingContext } =
    useContext(UserContext);
  const [temporadas, setTemporadas] = useState([]);
  const [search, setSearch] = useState('');
  const [error, setError] = useState({ error: false, msg: '' });
  const { isOpen, onOpen, onClose } = useDisclosure(); //modal reservar fecha

  const [yearList, setYearList] = useState([]);
  const [selectedYear, setSelectedYear] = useState(null);

  const [temporadaToDelete, setTemporadaToDelete] = useState(null);

  const [loadingRequest, setLoadingRequest] = useState(false);

  const defaultErrorTemporada = {
    isOpen: false,
    error: false,
    title: '',
    msg: '',
  }

  const [infoTemporada, setInfoTemporada] = useState(defaultErrorTemporada);
  const [maxYear, setMaxYear] = useState(null);



  const temporada_default = {
    id: null,
    nombre: '',
    fechaInicio: '',
    fechaFin: '',
    tipo: null,
    isOpenTemporada: false,
  }

  const [{
    id,
    nombre,
    fechaInicio,
    fechaFin,
    tipo,
    isOpenTemporada,
  }, setTemporada] = useState(temporada_default);

  const {
    isOpen: isOpenWarning,
    onOpen: onOpenWarning,
    onClose: onCloseWarning,
  } = useDisclosure();

  const openCleanTemporada = () => {
    setTemporada({
      ...temporada_default,
      isOpenTemporada: true,
    });
  }

  const closeTemporada = () => {
    setTemporada(temporada_default);
  }

  const handleTemporadaEdit = (name, value) => {
    setTemporada((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  }

  const requestMaxYear = async () => {
    try {
      const response = await getMaxYear();
      setMaxYear(response.data.maxYear);
    } catch (err) {
      console.log(err);
    }
  }



  const requestTemporadas = async () => {
    setIsLoadingContext(true);
    try{
      const response = await getTemporadas(selectedYear ? selectedYear.value : null);
      if (response.status === 200) {
        const parsedTime = response.data.map((temporada) => {
          return {
            ...temporada,
            fechaInicio: new Date(temporada.fechaInicio),
            fechaFin: new Date(temporada.fechaFin),
          };
        });
        setTemporadas(response.data);
      } else {
        console.error('Error Obteniendo amenidades');
      }
    }catch(err){
      console.log(err);
    }finally{
      setIsLoadingContext(false);
    }
  }

  const generateYearList = () => {
    const startYear = 2024;
    let years = [];
    for (let i = startYear; i <= maxYear; i++) {
      years.push({
        value: i,
        label: i,
      })
    }
    setYearList(years);
  }

  const requestCreateTemporada = async () => {
    const data = {
      nombre,
      fechaInicio: (new Date(fechaInicio)).toISOString(),
      fechaFin: (new Date(fechaFin)).toISOString(),
      tipo,
    }

    setLoadingRequest(true);

    try{
      const response = await postTemporada(data);
      closeTemporada();
      requestTemporadas();
      requestMaxYear();
    } catch(err){
      const errorMessage = err.response.data.msg ? `Error: ${err.response.data.msg}.` : t('CREATE_SEASON_ERROR');
      setInfoTemporada({
        isOpen: true,
        error: true,
        title: 'Error',
        msg: errorMessage
      });
    } finally {
      setLoadingRequest(false);
    }
  }

  const requestUpdateTemporada = async () => {
    const data = {
      id,
      nombre,
      fechaInicio: (new Date(fechaInicio)).toISOString(),
      fechaFin: (new Date(fechaFin)).toISOString(),
      tipo,
    }
    setLoadingRequest(true);
    try {
      const response = await putTemporada(data);
      closeTemporada();
      requestTemporadas();
      requestMaxYear();
    }
    catch (err){
      const errorMessage = err.response.data.msg ? `Error: ${err.response.data.msg}.` : t('UPDATE_SEASON_ERROR');
      setInfoTemporada({
        isOpen: true,
        error: true,
        title: 'Error',
        msg: errorMessage
      });
    } finally {
      setLoadingRequest(false);
    }
  }

  const requestDeleteTemporada = async () => {
    setLoadingRequest(true);
    try{
      const response = await deleteTemporada(temporadaToDelete.id);
      setTemporadaToDelete(null);
      requestTemporadas();
      requestMaxYear();
    } catch(err){
      const errorMessage = err.response.data.msg ? `Error: ${err.response.data.msg}.` : t('DELETE_SEASON_ERROR');
      setInfoTemporada({
        isOpen: true,
        error: true,
        title: 'Error',
        msg: errorMessage
      });
    } finally {
      setLoadingRequest(false);
    }
  }



  useEffect(() => {
    if(!maxYear){
      requestMaxYear();
    }else{
      generateYearList();
    }
  }, [maxYear]);

  useEffect(() => {
    requestTemporadas();
  }, [selectedYear]);

  const renderAddEditTemporadaModal = () => {
    const tipoLista = [
      { value: 'NOCHEHOTELERA', label: t('HOTEL_NIGHT') },
      { value: 'ALTA', label: t('HIGH') },
      { value: 'BAJA', label: t('LOW') },
    ]
    return (
      <Modal isOpen={isOpenTemporada} onClose={closeTemporada}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            {id ? t('EDIT_SEASON') : t('ADD_SEASON')}
          </ModalHeader>
          <ModalCloseButton color={'black'} />
          <ModalBody>
            <div className="form-group">
              <label>Nombre</label>
              <input
                type="text"
                className="form-control"
                value={nombre}
                onChange={(e) => handleTemporadaEdit('nombre', e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Fecha de Inicio</label>
              <input
                type="date"
                className="form-control"
                value={fechaInicio}
                max={fechaFin ? fechaFin : null}
                onChange={(e) => handleTemporadaEdit('fechaInicio', e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Fecha de Término</label>
              <input
                type="date"
                className="form-control"
                value={fechaFin}
                min={fechaInicio}
                onChange={(e) => handleTemporadaEdit('fechaFin', e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Tipo</label>
              <Select
                options={tipoLista}
                value={tipoLista.find((t) => t.value === tipo)}
                onChange={(value) => handleTemporadaEdit('tipo', value.value)}
              />
            </div>
            <div className="form-group">
              <Button 
                colorScheme="blue" 
                onClick={id ? requestUpdateTemporada : requestCreateTemporada}
                isLoading={loadingRequest}
                loadingText={t('SAVING')}
                disabled={loadingRequest}
                >
                {id ? t('EDIT') : t('ADD_SEASON')}
              </Button>
            </div>
          </ModalBody>
        </ModalContent>
      </Modal>
    )
  }

  return (
    <div className="p-5">
      <ModalTemporadas
        isOpen={isOpen}
        onClose={onClose}
      />
      <div className="w-100 mt-5">
        {isLoadingContext ? (
          <Loading />
        ) : (
          <Fragment>
            {
              renderAddEditTemporadaModal()
            }
            <ConfirmModal
              title={t('DELETE_SEASON')}
              message={t('CONFIRM_DELETE_SEASON')}
              isOpen={temporadaToDelete !== null}
              isLoading={loadingRequest}
              onClose={() => setTemporadaToDelete(null)}
              onConfirm={requestDeleteTemporada}
            />
            <InfoModal
              title={infoTemporada.title}
              message={infoTemporada.msg}
              isOpen={infoTemporada.isOpen}
              onClose={() => setInfoTemporada(defaultErrorTemporada)}
              isError={infoTemporada.error}
            />
            <div className="d-flex justify-content-between">
              <div style={{flex: 1, marginRight: '10px'}}>
                <Select
                  options={yearList}
                  onChange={(value) => {
                    setSelectedYear(value);
                  }}
                  value={selectedYear}
                  placeholder={t('SELECT_YEAR')}
                  isClearable
                />
              </div>
              <Button colorScheme="blue" onClick={openCleanTemporada}>
                + {t('CREATE_NEW_SEASON')}
              </Button>
            </div>
            <div
              className="table-responsive"
              style={{ maxHeight: '450px', overflowY: 'scroll' }}
            >
              <table className="table">
                <thead>
                  <tr>
                    <th className="col-sm px-sm-2"> {t('START_DATE')}</th>
                    <th className="col-sm px-sm-2"> {t('END_DATE')}</th>
                    <th className="col-sm px-sm-2"> {t('SEASON_TYPE')}</th>
                    <th></th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {temporadas.map((temporada, ix) => (
                    <tr key={ix}>
                      <td>{temporada.fechaInicio.split('T')[0]}</td>
                      <td>{temporada.fechaFin.split('T')[0]}</td>
                      <td>
                        {temporada.tipo == 'NOCHEHOTELERA'
                          ? 'NOCHE HOTELERA'
                          : temporada.tipo}
                      </td>
                      <td>
                        <Button colorScheme="blue" onClick={() => {
                          setTemporada({
                            id: temporada.id,
                            nombre: temporada.nombre,
                            fechaInicio: temporada.fechaInicio.split('T')[0],
                            fechaFin: temporada.fechaFin.split('T')[0],
                            tipo: temporada.tipo,
                            isOpenTemporada: true,
                          })}}>
                          {t('EDIT')}
                        </Button>
                      </td>
                      <td>
                        <Button 
                          colorScheme="red" 
                          onClick={() => setTemporadaToDelete(temporada)}>
                          {t('DELETE')}
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Fragment>
        )}
      </div>
    </div>
  );
};

export default Temporadas;
